import * as React from "react";

import "./sub-section-body.scss";

import {cs}    from "@Common/react/chain-services";
import {Radio} from "@Common/ui-components/heavy/common/design2/radio/radio";

export const SubSectionBody = ({content, xdQaName=undefined}) => cs(
    () => (
        <div className="sub-section-body-7ww">
            <div className="checkbox">
                {Radio({
                    selected: true,
                    xdQaName
                })}
            </div>
            <div className="content">
                {content}
            </div>
        </div>
    ),
);
